export const getLoyaltyMultiplier = async (sku: string) => {
  if (!sku) return `${sku}-1`

  const response = await fetch(`/api/product/getLoyaltyMultiplier/${sku}`)
  if (!response.ok) return `${sku}-1`
  const result = await response.json()

  return result as string
}
